import React from 'react';
import { Skeleton } from '../../components/ui/skeleton';
import './AppRegisterSkeleton.scss';

const AppRegisterSkeleton = () => (
  <div className="app-register-skeleton">
    {/* Page Header */}
    <div className="app-register-skeleton__page-header">
      <div className="app-register-skeleton__page-header-left">
        <Skeleton className="app-register-skeleton__back-button" />
        <div className="app-register-skeleton__page-header-text">
          <Skeleton className="app-register-skeleton__page-title" />
          <Skeleton className="app-register-skeleton__page-subtitle" />
        </div>
      </div>
      <Skeleton className="app-register-skeleton__save-button" />
    </div>

    {/* Two-column layout */}
    <div className="app-register-skeleton__grid">
      {/* Left Column - Account Information */}
      <div className="app-register-skeleton__card">
        <div className="app-register-skeleton__card-header">
          <Skeleton className="app-register-skeleton__icon" />
          <div className="app-register-skeleton__card-text">
            <Skeleton className="app-register-skeleton__card-title" />
            <Skeleton className="app-register-skeleton__card-subtitle" />
          </div>
        </div>

        <div className="app-register-skeleton__card-content">
          {/* Email field */}
          <div className="app-register-skeleton__field">
            <Skeleton className="app-register-skeleton__label" />
            <Skeleton className="app-register-skeleton__input" />
          </div>

          {/* Password fields */}
          <div className="app-register-skeleton__field-row">
            <div className="app-register-skeleton__field">
              <Skeleton className="app-register-skeleton__label" />
              <Skeleton className="app-register-skeleton__input" />
            </div>
            <div className="app-register-skeleton__field">
              <Skeleton className="app-register-skeleton__label" />
              <Skeleton className="app-register-skeleton__input" />
            </div>
          </div>

          {/* Google Link */}
          <div className="app-register-skeleton__field">
            <Skeleton className="app-register-skeleton__label" />
            <Skeleton className="app-register-skeleton__input" />
          </div>

          {/* Yelp Link */}
          <div className="app-register-skeleton__field">
            <Skeleton className="app-register-skeleton__label" />
            <Skeleton className="app-register-skeleton__input" />
          </div>

          {/* Short Links */}
          <div className="app-register-skeleton__field-row">
            <div className="app-register-skeleton__field">
              <Skeleton className="app-register-skeleton__label" />
              <Skeleton className="app-register-skeleton__input" />
            </div>
            <div className="app-register-skeleton__field">
              <Skeleton className="app-register-skeleton__label" />
              <Skeleton className="app-register-skeleton__input" />
            </div>
          </div>

          {/* Feature Flags */}
          <div className="app-register-skeleton__field">
            <Skeleton className="app-register-skeleton__label" />
            <Skeleton className="app-register-skeleton__switch" />
          </div>
        </div>
      </div>

      {/* Right Column - Message Configuration */}
      <div className="app-register-skeleton__card">
        <div className="app-register-skeleton__card-header">
          <Skeleton className="app-register-skeleton__icon" />
          <div className="app-register-skeleton__card-text">
            <Skeleton className="app-register-skeleton__card-title" />
            <Skeleton className="app-register-skeleton__card-subtitle" />
          </div>
        </div>

        <div className="app-register-skeleton__card-content app-register-skeleton__card-content--flex">
          {/* iPhone Preview */}
          <Skeleton className="app-register-skeleton__phone-preview" />

          {/* Message inputs */}
          <div className="app-register-skeleton__message-inputs">
            <div className="app-register-skeleton__field">
              <Skeleton className="app-register-skeleton__label" />
              <Skeleton className="app-register-skeleton__textarea" />
            </div>

            <div className="app-register-skeleton__field">
              <Skeleton className="app-register-skeleton__label" />
              <Skeleton className="app-register-skeleton__image-area" />
              <Skeleton className="app-register-skeleton__button" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AppRegisterSkeleton;
